/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/prefer-default-export */
import { Link } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import { homeButtonStyles } from "../../../ThemeProvider";
import { useIntl } from "../../../../_metronic/i18n/customUseIntl";
import useAdobeDataLayer from "../../../sustell_15/analytics/adobeDataLayer";
import featureFlags from "../../utils/featureFlags";

export const HomeButton = ({
  bkgImg,
  icon,
  title = "Title",
  intro = "",
  translationKeyTitle,
  translationKeyText,
  applyGradientOverlay = false,
  href = featureFlags.homepageFP ? '/v2/homepage' : '/homepage',
}) => {
  const { ctaClickEvent } = useAdobeDataLayer();

  const intl = useIntl();
  title = translationKeyTitle
    ? intl.formatMessage({ id: translationKeyTitle })
    : title;
  const introText = translationKeyText
    ? intl.formatMessage({ id: translationKeyText })
    : intro;

  const onClickLink = () => {
    ctaClickEvent(href, "link", title, "Home Page", "Home Page");
  };

  const backgroundImage = applyGradientOverlay
    ? `linear-gradient(128deg, rgba(23, 78, 68, 0.75) 9.97%, rgba(23, 78, 68, 0.225) 71.93%), url(${bkgImg})`
    : `url(${bkgImg})`;

  const classes = homeButtonStyles({ backgroundImage });

  return (
    <Link to={href} onClick={onClickLink} style={{ padding: 0 }}>
      <Box className={`${classes.buttonBackground} ${classes.buttonContainer}`}>
        <Typography variant="h3" className={classes.buttonTitle}>
          {title}
        </Typography>
        <Box className={classes.buttonIntro}>{introText}</Box>
        <img className={classes.buttonIcon} src={icon} alt={title} />
      </Box>
    </Link>
  );
};
